export default (duration: number) =>
  new Promise(resolve => {
    setTimeout(() => resolve(true), duration);
  });
